import React, { useState, useEffect } from 'react'
import { Button, Col, Form, Row, Card, Modal, Dropdown } from 'react-bootstrap'
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'

import 'bootstrap/dist/css/bootstrap.min.css'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'
import { FaArrowLeft, FaPrint, FaSyncAlt } from 'react-icons/fa'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import toast from 'react-hot-toast'
import Cookies from 'js-cookie'
import axios from 'axios'
import { Typeahead } from 'react-bootstrap-typeahead'
import { BsFunnelFill, BsSearch, BsArrowClockwise, BsCurrencyRupee, BsPrinterFill, BsTrashFill, BsThreeDotsVertical, BsPencilFill, BsClockHistory } from 'react-icons/bs'
import { LuGraduationCap } from 'react-icons/lu'
import { useAuth } from './AuthContext'
import { useSidebar } from './SidebarContext'
import ProfileDropdown from './commonComponents/ProfileDropdown'
import { useInstitute } from './commonComponents/InstituteContext'
import EditTransactionModal from './commonComponents/EditTransactionModal'

export default function ManageStudentFees() {
  const { logout } = useAuth()
  const { isCollapsed } = useSidebar()
  const [marginLeft, setMarginLeft] = useState('0px')
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 768 : false,
  )
  const [logoError, setLogoError] = useState(false)
  const { logo, name, id } = useInstitute();
  const [showFilterCard, setShowFilterCard] = useState(true)
  const location = useLocation()
  const {
    selectedStudent: navStudent,
    selectedFees: navFees,
    selectedData: navData,
    selectedStudentId: navStudentId,
    selectedClassId: navClassId,
    selectedCourseId: navCourseId,
  } = location.state || {}
  console.log('NAVIGATION DATA ', location.state)
  console.log('navStudent:', navStudent)
  console.log('navFees:', navFees)
  console.log('navData:', navData)
  console.log('navStudentId:', navStudentId)
  console.log('navClassId:', navClassId)
  console.log('navCourseId:', navCourseId)
  const { student_id, course_id, class_id } = useParams()
  console.log('Student ID:', student_id)
  console.log('Course ID:', course_id)
  console.log('Class ID:', class_id)

  const [selectedFees, setSelectedFees] = useState([])
  const [openTable, setOpenTable] = useState(false)
  const [courses, setCourses] = useState([])
  const [classes, setClasses] = useState([])
  const [allStudents, setAllStudents] = useState([])
  const [filteredStudents, setFilteredStudents] = useState([])
  const [selectedStudent, setSelectedStudent] = useState(null)
  const [selectedData, setSelectedData] = useState([])
  const [selectedCourseId, setSelectedCourseId] = useState(null)
  const [selectedStudentId, setSelectedStudentId] = useState(null)
  const [selectedClassId, setSelectedClassId] = useState(null)
  const [hasModifiedFields, setHasModifiedFields] = useState(false)
  const [currentStudent, setCurrentStudent] = useState(null)
  const [selectedStudentIdParams, setSelectedStudentIdParams] = useState(null)
  const [courseNameIs, setCourseNameIs] = useState('')
  const [ourStudents, setOurStudents] = useState([])
  const [showCancelModal, setShowCancelModal] = useState(false)
  const [feeToCancel, setFeeToCancel] = useState(null)
  const [isCancelling, setIsCancelling] = useState(false)
  const [showEditModal, setShowEditModal] = useState(false)
  const [selectedTransactionId, setSelectedTransactionId] = useState(null)

  const formatINR = (value, emptyFallback = '-') => {
    if (value === null || value === undefined || value === '') return emptyFallback
    const num = Number(value)
    if (Number.isNaN(num)) return emptyFallback
    return `₹ ${num}`
  }

  const formatFeeDate = (value) => {
    if (!value) return '-'
    return new Date(value).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
    })
  }

  const getOnlineAmount = (fee) => {
    const method = (fee?.payment_method || '').toLowerCase()
    if (method === 'split') return fee?.online
    if (method === 'online') return fee?.transaction_amount
    return ''
  }

  const getCashAmount = (fee) => {
    const method = (fee?.payment_method || '').toLowerCase()
    if (method === 'split') return fee?.cash
    if (method === 'cash') return fee?.transaction_amount
    return ''
  }

  const handleSelectFee = (feeId) => {
    setSelectedFees((prev) =>
      prev.includes(feeId)
        ? prev.filter((id) => id !== feeId)
        : [...prev, feeId],
    )
  }

  useEffect(() => {
    const fetchStudentFeeData = async () => {
      try {
        const res = await ApiEndpoints.getAllFeesByStudentId(
          student_id,
          course_id,
          // class_id,
        )
        // console.log('student:', res.data.student)
        console.log('student:', res)

        console.log('fees:', res.data.fees)
        // console.log('selectedStudent:', res.data.selectedStudent)
        console.log('Response from params:', res.data.data)

        console.log('student_id', student_id)
        // setSelectedStudentIdParams(student_id)

        setSelectedStudentId(student_id)
        setSelectedCourseId(course_id)
        setSelectedClassId(class_id)

        setSelectedData(res.data.fees || res.data.data || [])

        setOpenTable(true)
      } catch (err) {
        console.error('Failed to fetch student fee data:', err)
      }
    }

    if (navStudent && navData) {
      setSelectedStudent(navStudent)
      setSelectedData(navData)
      setOpenTable(true)
    } else if (student_id && course_id && class_id) {
      fetchStudentFeeData()
    }
  }, [navStudent, navData, student_id, course_id, class_id])

  useEffect(() => {
    if (navStudent) {
      setSelectedStudent(navStudent)
    }
    if (navFees) {
      setSelectedFees(navFees)
    }
    if (navData) {
      setSelectedData(navData)
      setOpenTable(true)
    }

    if (navStudentId || student_id) {
      setSelectedStudentId(navStudentId || student_id)
    }
    if (navClassId || class_id) {
      setSelectedClassId(navClassId || class_id)
    }
    if (navCourseId || course_id) {
      setSelectedCourseId(navCourseId || course_id)
    }
  }, [
    navStudent,
    navFees,
    navData,
    navStudentId,
    navCourseId,
    navClassId,
    student_id,
    class_id,
    course_id,
  ])

  useEffect(() => {
    if (student_id && course_id && class_id && selectedFees?.length > 0) {
      // const foundStudent = allStudents.find((s) => s.id === Number(student_id))
      // if (foundStudent) {
      //   setSelectedStudent(foundStudent)
      console.log('Student ID during fetch:', student_id)
      console.log('Course ID during fetch:', course_id)
      console.log('Class ID during fetch:', class_id)

      setSelectedCourseId(course_id)
      setSelectedStudentId(student_id)
      setSelectedClassId(class_id)
      setOpenTable(true)

      // Fetch fees
      ApiEndpoints.getAllFeesByStudentId(student_id, course_id)
        .then((res) => {
          setSelectedData(res.data.data)
        })
        .catch((error) => {
          console.error('Failed to load fees:', error)
          setSelectedData([])
        })
      // }
    }
  }, [student_id, course_id, class_id])

  console.log('selectedCourseID:', selectedCourseId)

  // useEffect(() => {
  //   const courseName = ourStudents.forEach((st) => {
  //     const course = courses.find((cs) => cs.id === st.selectedCourseId)
  //     const existCourse = course?.name || ''
  //     console.log(`Student: ${st.name}, existCourse: ${existCourse}`)
  //     setCourseNameIs(existCourse)
  //   })
  //   console.log('Course Name:', courseName)
  // }, [ourStudents, courses])

  useEffect(() => {
    if (selectedCourseId) {
      ApiEndpoints.getAllClassesByCourseId(selectedCourseId)
        .then((res) => {
          const { data } = res
          if (data.status === false || !data.data?.length) {
            setClasses([])
          } else {
            setClasses(data.data)
            // setSelectedClassId(classId)
          }
        })
        .catch(() => {
          setClasses([])
        })
    }
  }, [selectedCourseId])
  useEffect(() => {
    const institueId = Cookies.get('institute_id')
    const userCookie = Cookies.get('user')
    let token = null
    console.log('InstituteID', institueId)

    if (userCookie) {
      try {
        const user = JSON.parse(userCookie)
        token = user.token
        console.log('TOKEN:', token)
      } catch (err) {
        console.error(' Failed to parse user cookie', err)
      }
    } else {
      console.warn('user cookie not found')
    }

    // const fetchFilteredData = async () => {
    //   console.log('Insti ID: ', institueId)
    //   try {
    //     const headers = {
    //       'Content-Type': 'application/json',
    //       Authorization: `Bearer ${token}`,
    //       'institute-Id': Number(institueId),
    //     }

    //     console.log('Request Headers:', headers)

    //     const response = await axios.get(
    //       BASE_URL+'/student/all',
    //       { headers },
    //     )

    //     const studentRes = response.data.data
    //     console.log('Students response: ', studentRes)
    //     const studentId = student_id // the ID you want to search for
    //     const student = studentRes.find(
    //       (st) => Number(st.id) === Number(studentId),
    //     )
    //     const name = student || 'N/A'
    //     console.log('Select Student data:', name)
    //     const studentParId = studentRes.find(
    //       (st) => Number(st.id) === Number(student_id),
    //     )
    //     console.log('studentParId with data', studentParId)

    //     const studentParNameId = studentParId
    //     console.log('studentParId:', studentParNameId.id)
    //     console.log('studentParNameId:', studentParNameId?.name)

    //     setFilteredStudents(studentParId)
    //     setSelectedStudentIdParams(studentParId)

    //     setAllStudents(response.data.data)
    //     setSelectedStudent(name)
    //     // setData(response.data.data)
    //   } catch (error) {
    //     toast.error(error.response?.data?.message || 'Something went wrong')
    //   }
    // }
    const fetchFilteredData = async () => {
      console.log('Insti ID: ', institueId)
      try {
        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          'institute-Id': Number(institueId),
        }
        console.log('Request Headers:', headers)

        const res = await axios.get(
          BASE_URL+'/student/all',
          { headers },
        )
        const students = res.data.data
        console.log('Students response: ', students)
        setOurStudents(students)
        const student =
          students.find((st) => Number(st.id) === Number(student_id)) || 'N/A'
        console.log('Select Student data:', student)

        const studentParId = students.find(
          (st) => Number(st.id) === Number(student_id),
        )
        console.log('studentParId with data', studentParId)
        console.log('studentParId:', studentParId?.id)
        console.log('studentParNameId:', studentParId?.name)

        setFilteredStudents(studentParId)
        setSelectedStudentIdParams(studentParId)
        setAllStudents(students)
        setSelectedStudent(student)
      } catch (error) {
        toast.error(error.response?.data?.message || 'Something went wrong')
      }
    }

    fetchFilteredData()
  }, [])

  useEffect(() => {
    ApiEndpoints.getAllCourses()
      .then((res) => setCourses(res.data.data))
      .catch(console.error)
  }, [])

  useEffect(() => {
    if (course_id) {
      handleCourseChange({ target: { value: course_id } })
    }
  }, [course_id])

  useEffect(() => {
    if (class_id && allStudents.length > 0) {
      handleClassChange({ target: { value: class_id } })
    }
  }, [class_id, allStudents])

  useEffect(() => {
    if (student_id && filteredStudents.length > 0) {
      const student = filteredStudents.find((s) => s.id === Number(student_id))
      console.log('student ..........', student)

      if (student) {
        setSelectedStudentId(student.id)

        setSelectedStudent(student)
        // console.log('setSelectedStudentId', student.id)
        // console.log('setSelectedStudentIdParams', student.id)
        console.log('setSelectedStudent', student.id)
      }
    }
    // else if (selectedStudentIdParams && filteredStudents.length > 0) {
    //   const student = filteredStudents.find((s) => s.id === Number(student_id))
    //   console.log('student from params', student)
    // }
  }, [student_id, filteredStudents])

  useEffect(() => {
    if (!location.state) {
      // Hard refresh happened - clear everything manually
      setSelectedStudent(null)
      setSelectedFees([])
      setSelectedData([])
      setSelectedCourseId(null)
      setSelectedClassId(null)
      setSelectedStudentId(null)
      setOpenTable(false)
    }
  }, [location.state])

  const handleCourseChange = async (e) => {
    setHasModifiedFields(true)
    const courseId = e.target.value
    setSelectedCourseId(courseId)
    setClasses([])
    setFilteredStudents([])
    setSelectedData([])
    setSelectedStudentId(null)
    setSelectedClassId(null)
    setSelectedStudent(null)

    console.log('courseId ', courseId, 'and', 'course_id', course_id)
    setOpenTable(true)
    if (courseId) {
      try {
        const res = await ApiEndpoints.getAllClassesByCourseId(courseId)
        const { data } = res
        if (data?.status === false || !data?.data?.length) {
          toast.error(data?.message || 'No classes found for this course')
          setClasses([])
          setOpenTable(false)
        } else {
          setClasses(data.data)
        }
      } catch (error) {
        const message = error?.response?.data?.message
        if (message === 'No classes found for this course') {
          toast.error(message)
        } else {
          console.error('Error fetching classes:', error)
          toast.error('Something went wrong while fetching classes.')
        }
        setClasses([])
        setOpenTable(false)
      }
    }
  }

  const handleClassChange = (e) => {
    setHasModifiedFields(true)
    const classId = e.target.value

    const filtered = allStudents.filter(
      (student) => student.class_id === Number(classId),
    )
    console.log('filtered', filtered)
    // setFilteredStudents(filtered)
    setSelectedClassId(classId)
    setSelectedStudentId(null)
    setSelectedStudent(null)
    setSelectedData([])
    setSelectedFees([])
    setOpenTable(true)

    if (classId) {
      const institueId = Cookies.get('institute_id')
      const userCookie = Cookies.get('user')
      let token = null
      if (userCookie) {
        try {
          token = JSON.parse(userCookie)?.token || null
        } catch (err) {
          console.error('Failed to parse user cookie', err)
        }
      }
      const headers = {
        'institute-Id': Number(institueId),
        Authorization: token ? `Bearer ${token}` : undefined,
      }
      axios
        .get(
          BASE_URL+`/get/student/by-class?class_id=${classId}`,
          { headers },
        )
        .then((res) => {
          console.log('Students after class select:', res.data.data)
          setFilteredStudents(res.data.data)
        })
        .catch((error) => {
          // This is where 404 or other errors come
          if (
            error.response?.data?.message === 'No classes found for this course'
          ) {
            console.error('No classes found for this course.')
          } else {
            console.error('Error fetching classes:', error)
            console.error('Something went wrong while fetching classes.')
          }
          setClasses([])
        })
    }
  }
  useEffect(() => {
    if (selectedCourseId && selectedStudentId) {
      ApiEndpoints.getAllFeesByStudentId(selectedStudentId, selectedCourseId)
        .then((res) => {
          console.log('Response:', res.data.data)
          setSelectedData(res.data.data)
          setOpenTable(true)
        })
        .catch((err) => {
          console.error('Failed to fetch fees', err)
          setSelectedData([])
        })
    }
    // }
  }, [selectedCourseId, selectedStudentId])

  const handleStudentChange = async (e) => {
    setHasModifiedFields(true)
    const studentId = e.target.value
    setSelectedStudentId(studentId)
    // setOpenTable(true)
    const student = filteredStudents.find((s) => s.id === Number(studentId))
    setSelectedStudent(student)
    setSelectedFees([])
    setOpenTable(true)

    if (selectedStudentId && selectedCourseId) {
      try {
        const res = await ApiEndpoints.getAllFeesByStudentId(
          selectedStudentId,
          selectedCourseId,
        )
        console.log('Last response:', res.data.data)

        setSelectedData(res.data.data) // Store fees data properly
      } catch (error) {
        console.error('Error fetching fees:', error.response?.data?.message)
        // toast.error(error.response?.data?.message)
        setSelectedData([])
      }
    }
  }

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        const expandedWidth = 245
        const collapsedWidth = 85
        const gap = 1

        setMarginLeft(
          isCollapsed
            ? `${collapsedWidth + gap}px`
            : `${expandedWidth + gap}px`,
        )
      } else {
        setMarginLeft('0px')
      }

      setIsMobile(window.innerWidth <= 768)
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [isCollapsed])

  const navigate = useNavigate()
  const handlePrint = (fee) => {
    if (!selectedStudent && !selectedStudentIdParams?.id) {
      toast.error('Select a student to print the receipt.')
      return
    }

    const studentId = selectedStudent?.id || selectedStudentIdParams?.id
    const feeIdsParam = selectedFees.length ? selectedFees.join(',') : fee?.id

    navigate(`/FeeRecipt/${studentId}/${feeIdsParam}`, {
      state: {
        fee,
        selectedStudent,
        selectedFees: selectedFees.length ? selectedFees : [fee?.id],
        selectedData,
        selectedCourseId,
        selectedClassId,
        selectedStudentId,
        selectedStudentIdParams,
      },
    })
  }

  const resetForm = () => {
    setSelectedFees([])
    setOpenTable(false)
    setCourses([])
    setClasses([])
    setAllStudents([])
    setFilteredStudents([])
    setSelectedStudent(null)
    setSelectedStudentId(null)
    setSelectedCourseId(null)
    setSelectedClassId(null)
    setSelectedData([])
    setCurrentStudent(null)
    setHasModifiedFields(false)
  }
  useEffect(() => {
    // If all params are missing, reset the form
    if (!student_id && !course_id && !class_id) {
      resetForm()
      setCourses(courses)
    }
  }, [student_id, course_id, class_id])

  const handleRefresh = () => {
    setClasses([])
    setFilteredStudents([])
    setSelectedData([])
    setAllStudents([])
    setSelectedStudentId(null)
    setSelectedCourseId(null)
    setSelectedClassId(null)
    setSelectedStudent(null)
    setOpenTable(false)

    navigate(`/ManageStudentFees`)
  }
  const handleBack = (studentId) => {
    if (!studentId) {
      toast.error('No student selected. Please select a student first')
      return
    }
    navigate(`/student/profile/${studentId}`)
  }

  const handleTakeFeesButton = () => {
    const studentId = selectedStudentId || selectedStudentIdParams?.id
    console.log('studentId', studentId)
    if (!selectedCourseId) {
      console.error('Course ID is not define')
    } else if (!studentId) {
      console.error('Student ID is not define')
    } else {
      navigate(`/TakeFees/${studentId}/${selectedCourseId}`)
    }
  }

  const refreshFeesList = async () => {
    const studentId = selectedStudentId || selectedStudentIdParams?.id
    if (!studentId || !selectedCourseId) return

    try {
      const res = await ApiEndpoints.getAllFeesByStudentId(studentId, selectedCourseId)
      setSelectedData(res.data.fees || res.data.data || [])
    } catch (err) {
      console.error('Failed to refresh fees:', err)
    }
  }

  const handleConfirmCancel = async () => {
    if (!feeToCancel) return
    setIsCancelling(true)

    const userCookie = Cookies.get('user')
    let token = null

    try {
      const user = JSON.parse(userCookie)
      token = user.token

      const response = await axios.post(
        BASE_URL + `/cancel-fee?fee_id=${feeToCancel.id}`,
        {},
        { headers: { Authorization: `Bearer ${token}` } },
      )

      toast.success(response.data.message || 'Fee cancelled successfully')
      setShowCancelModal(false)
      setFeeToCancel(null)
      setSelectedFees((prev) => prev.filter((id) => id !== feeToCancel.id))
      await refreshFeesList()
    } catch (error) {
      toast.error(error.response?.data?.message || 'Failed to cancel fee')
    } finally {
      setIsCancelling(false)
    }
  }

  console.log('selectedStudentId:', selectedStudentId)
  console.log('selectedCourseId:', selectedCourseId)
  console.log('selectedStudentIdParams:', selectedStudentIdParams?.id)
  console.log('selectedStudentIdParamsName:', selectedStudentIdParams?.name)

  console.log('selectedData:', selectedData)

  return (
    <>
      <style>
        {`
        .hover-white:hover{
        color:white !important;
        }
        
        .dropdown-toggle-no-caret::after {
          display: none !important;
        }
        
        /* Fix Typeahead dropdown visibility */
        .fees-status-typeahead {
          position: relative !important;
        }

        .fees-status-typeahead .rbt {
          position: relative !important;
          width: 100% !important;
        }

        .rbt-menu {
          z-index: 2000 !important;
          max-height: 240px !important;
          overflow-y: auto !important;
          overflow-x: hidden !important;
          background-color: #ffffff !important;
          border: 1px solid #D1D3D4 !important;
          border-radius: 8px !important;
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12) !important;
          margin-top: 4px !important;
          padding: 4px 0 !important;
        }
        
        .rbt-input-wrapper {
          position: relative !important;
        }

        .rbt .form-control,
        .rbt-input-main,
        .rbt .rbt-input-multi,
        .rbt .rbt-input {
          border-radius: 8px !important;
          border: 1px solid #D1D3D4 !important;
          font-size: 14px !important;
          padding: 8px 12px !important;
          min-height: 42px !important;
          background-color: #ffffff !important;
          color: #111827 !important;
          transition: all 0.2s ease !important;
          font-family: 'Inter', system-ui, sans-serif !important;
        }
        
        .rbt-input-main:focus,
        .rbt .form-control:focus,
        .rbt.focus .rbt-input {
          border-color: #223843 !important;
          outline: none !important;
          box-shadow: 0 0 0 3px rgba(34, 56, 67, 0.12) !important;
        }

        .fees-status-typeahead .rbt-close-content {
          display: none !important;
        }

        .fees-status-typeahead .rbt-aux .rbt-close {
          opacity: 0.65;
          box-shadow: none;
          background-size: 0.65em;
        }

        .rbt-token,
        .rbt .rbt-token {
          background-color: #E8EEF1 !important;
          color: #111827 !important;
          border-radius: 6px !important;
          font-size: 13px !important;
          max-width: 100% !important;
          white-space: normal !important;
          word-break: break-word !important;
        }
        
        .rbt-menu .dropdown-item {
          padding: 10px 12px !important;
          font-size: 14px !important;
          font-family: 'Inter', system-ui, sans-serif !important;
          color: #111827 !important;
          background-color: #ffffff !important;
          cursor: pointer !important;
          white-space: normal !important;
          word-break: break-word !important;
        }
        
        .rbt-menu .dropdown-item:hover,
        .rbt-menu .dropdown-item.active {
          background-color: #F3F4F6 !important;
          color: #111827 !important;
        }
        
        .filter-card-container {
          overflow: visible !important;
          position: relative !important;
          z-index: 10 !important;
        }
      `}
      </style>
      <div 
        style={{ 
          marginLeft,
          transition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          willChange: 'margin-left',
          WebkitTransition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          position: 'relative',
          zIndex: 1,
          marginTop: '0px',
          marginRight: '0px',
          marginBottom: '0px',
          paddingLeft: isCollapsed ? '12px' : '12px',
          paddingRight: isCollapsed ? '12px' : '12px',
        }}
      >
        {/* Header */}
        <div
          className="container-fluid p-0"
          style={{
            marginTop: window.innerWidth < 992 ? '55px' : '-12px',
            paddingLeft: '0px',
            paddingRight: '0px',
          }}
        >
        <div style={{ marginLeft: isMobile ? '-13px' : '-40px' }}>
          <div 
            className="d-flex justify-content-between align-items-center"
            style={{
              background: '#F3F4F6',
              paddingLeft: '28px',
              paddingRight: '28px',
              paddingTop: '12px',
              paddingBottom: '12px',
              overflow: 'visible',
              borderBottom: '1px solid #D1D3D4',
              width: '100%',
            }}
          >
            {/* Left: Title */}
            <div className="d-flex align-items-center gap-3">
              {/* School Logo */}
              <div style={{ 
                width: '40px', 
                height: '40px', 
                borderRadius: '50%', 
                overflow: 'hidden', 
                background: '#223843',
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center', 
                flexShrink: 0,
              }}>
                {!logoError ? (
                  <img 
                    src={logo} 
                    alt="School Logo" 
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    onError={() => setLogoError(true)}
                  />
                ) : (
                  <LuGraduationCap size={20} style={{ color: '#ffffff' }} />
                )}
              </div>
              
              <h3 
                className="m-0 fw-bold" 
                style={{ 
                  letterSpacing: '-0.02em',
                  overflow: 'visible',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  fontSize: 'clamp(18px, 2.5vw, 22px)',
                  color: '#223843',
                  lineHeight: '1.2',
                  fontFamily: 'Inter, system-ui, sans-serif',
                }}
              >
                Student Fees Management
                {(selectedStudent?.name?.toUpperCase() ||
                  selectedStudentIdParams?.name?.toUpperCase()) && (
                  <>
                    {' '} -{' '}
                    <span style={{ color: '#223843' }}>
                      {selectedStudent?.name?.toUpperCase() ||
                        selectedStudentIdParams?.name?.toUpperCase()}
                    </span>
                  </>
                )}
              </h3>
            </div>
            
            {/* Right: Profile Icon with Dropdown */}
            {!isMobile && ( 
              <ProfileDropdown logout={logout} />
            )}
          </div>
        </div>
        </div>
        <div
          className="container-fluid p-0 mt-4"
          style={{
            minHeight: '100vh',
            paddingLeft: isCollapsed ? '32px' : '40px',
            paddingRight: '32px',
            paddingTop: '32px',
            paddingBottom: '32px',
          }}
        >
          {/* Filter Toggle Button */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div className="d-flex align-items-center gap-3">
              <button
                onClick={() => setShowFilterCard(!showFilterCard)}
                style={{
                  width: '48px',
                  height: '48px',
                  borderRadius: '50%',
                  backgroundColor: showFilterCard ? '#223843' : '#ffffff',
                  border: '1px solid #D1D3D4',
                  color: showFilterCard ? '#ffffff' : '#223843',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = showFilterCard ? '#223843' : '#223843'
                  e.currentTarget.style.color = '#ffffff'
                  e.currentTarget.style.borderColor = showFilterCard ? '#223843' : '#223843'
                  e.currentTarget.style.transform = 'scale(1.05)'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = showFilterCard ? '#223843' : '#ffffff'
                  e.currentTarget.style.color = showFilterCard ? '#ffffff' : '#223843'
                  e.currentTarget.style.borderColor = '#D1D3D4'
                  e.currentTarget.style.transform = 'scale(1)'
                }}
                title={showFilterCard ? 'Hide Filters' : 'Show Filters'}
              >
                <BsFunnelFill size={20} />
              </button>
            </div>
          </div>

          {/* Modern Filter Section */}
          <div 
            className="filter-card-container"
            style={{
              maxHeight: showFilterCard ? 'none' : '0',
              overflow: showFilterCard ? 'visible' : 'hidden',
              transition: 'max-height 0.3s ease-in-out',
              marginBottom: showFilterCard ? '24px' : '0',
              position: 'relative',
              zIndex: showFilterCard ? 10 : 1,
            }}
          >
            {showFilterCard && (
              <Card 
                style={{
                  border: '1px solid #D1D3D4',
                  borderRadius: '12px',
                  backgroundColor: '#ffffff',
                  overflow: 'visible',
                  position: 'relative',
                }}
              >
                {/* Header */}
                <div 
                  style={{
                    background: '#ffffff',
                    padding: '20px',
                    borderBottom: '1px solid #F3F4F6',
                  }}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center gap-3">
                      <div 
                        style={{
                          width: '40px',
                          height: '40px',
                          borderRadius: '50%',
                          backgroundColor: '#223843',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <BsSearch style={{ color: '#ffffff', fontSize: '18px' }} />
                      </div>
                      <div>
                        <h5 className="m-0 fw-semibold" style={{ color: '#111827', fontSize: '16px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                          Select Course, Class & Student
                        </h5>
                        <p className="m-0 mt-1" style={{fontSize: '13px', color: '#6b7280' }}>
                          Choose filters to view student fees
                        </p>
                      </div>
                    </div>
                    <div className="d-flex gap-2">
                      <button
                        onClick={handleRefresh}
                        style={{
                          width: '48px',
                          height: '48px',
                          borderRadius: '50%',
                          backgroundColor: '#223843',
                          border: 'none',
                          color: '#ffffff',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          cursor: 'pointer',
                          transition: 'all 0.2s ease',
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = '#223843'
                          e.currentTarget.style.transform = 'scale(1.05)'
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = '#223843'
                          e.currentTarget.style.transform = 'scale(1)'
                        }}
                        title="Refresh"
                      >
                        <BsArrowClockwise size={20} />
                      </button>
                    </div>
                  </div>
                </div>

                <Card.Body className="p-4" style={{ backgroundColor: '#ffffff', overflow: 'visible', position: 'relative' }}>
                  <Row className="g-3 text-start">
                    <Col xs={12} md={4} style={{ position: 'relative', zIndex: 1052 }}>
                      <div style={{
                        padding: '20px',
                        backgroundColor: '#F3F4F6',
                        borderRadius: '8px',
                        border: '1px solid #D1D3D4',
                        overflow: 'visible',
                        position: 'relative',
                      }}>
                        <div className="d-flex align-items-center gap-2 mb-3">
                          <div
                            style={{
                              width: '32px',
                              height: '32px',
                              borderRadius: '50%',
                              backgroundColor: '#10B981',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            <BsSearch style={{ color: '#ffffff', fontSize: '16px' }} />
                          </div>
                          <label className="fw-semibold mb-0" style={{ color: '#111827', fontSize: '14px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                            Select Course
                          </label>
                        </div>
                        <div className="fees-status-typeahead">
                          <Typeahead
                            id="course-select"
                            labelKey="name"
                            positionFixed
                            clearButton
                            onChange={(selected) => {
                              const course = selected[0]
                              if (course) {
                                handleCourseChange({ target: { value: course.id } })
                              } else {
                                handleCourseChange({ target: { value: '' } })
                              }
                            }}
                            options={courses}
                            placeholder="Select Course"
                            selected={courses.filter(
                              (cs) => cs.id === Number(selectedCourseId || course_id || ''),
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col xs={12} md={4} style={{ position: 'relative', zIndex: 1051 }}>
                      <div style={{
                        padding: '20px',
                        backgroundColor: '#F3F4F6',
                        borderRadius: '8px',
                        border: '1px solid #D1D3D4',
                        overflow: 'visible',
                        position: 'relative',
                      }}>
                        <div className="d-flex align-items-center gap-2 mb-3">
                          <div
                            style={{
                              width: '32px',
                              height: '32px',
                              borderRadius: '50%',
                              backgroundColor: '#10B981',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            <BsSearch style={{ color: '#ffffff', fontSize: '16px' }} />
                          </div>
                          <label className="fw-semibold mb-0" style={{ color: '#111827', fontSize: '14px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                            Select Class
                          </label>
                        </div>
                        <div className="fees-status-typeahead">
                          <Typeahead
                            id="class-select"
                            labelKey="class_name"
                            positionFixed
                            clearButton
                            onChange={(selected) => {
                              const cls = selected[0]
                              if (cls) {
                                handleClassChange({ target: { value: cls.id } })
                              } else {
                                handleClassChange({ target: { value: '' } })
                              }
                            }}
                            options={classes}
                            placeholder="Select Class"
                            selected={classes.filter(
                              (cs) => cs.id === Number(selectedClassId || class_id || ''),
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col xs={12} md={4} style={{ position: 'relative', zIndex: 1050 }}>
                      <div style={{
                        padding: '20px',
                        backgroundColor: '#F3F4F6',
                        borderRadius: '8px',
                        border: '1px solid #D1D3D4',
                        overflow: 'visible',
                        position: 'relative',
                      }}>
                        <div className="d-flex align-items-center gap-2 mb-3">
                          <div
                            style={{
                              width: '32px',
                              height: '32px',
                              borderRadius: '50%',
                              backgroundColor: '#10B981',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                            }}
                          >
                            <BsSearch style={{ color: '#ffffff', fontSize: '16px' }} />
                          </div>
                          <label className="fw-semibold mb-0" style={{ color: '#111827', fontSize: '14px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                            Select Student
                          </label>
                        </div>
                        <div className="fees-status-typeahead">
                          <Typeahead
                            id="student-select"
                            labelKey={(option) => {
                              const name = option.name || "";
                              const admission = option.admission_number || "";
                              return name && admission
                                ? `${name} - ${admission}`
                                : name || admission;
                            }}
                            positionFixed
                            clearButton
                            onChange={(selected) => {
                              if (selected.length > 0) {
                                const student = selected[0]
                                handleStudentChange({ target: { value: student.id } })
                              } else {
                                setSelectedStudentId('')
                                setSelectedStudent(null)
                                setSelectedFees([])
                                setSelectedData([])
                                setOpenTable(false)
                              }
                            }}
                            options={
                              Array.isArray(filteredStudents) ? filteredStudents : []
                            }
                            placeholder="Select Student"
                            selected={selectedStudent ? [selectedStudent] : []}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            )}
          </div>

        {/* Action Buttons */}
        {openTable && (
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3 mb-4">
            {((student_id && course_id && class_id) ||
              (selectedCourseId && selectedStudentId) ||
              selectedStudentIdParams) && (
              <div className="order-1 order-md-1 d-flex align-items-center gap-2">
                <div
                  className="d-flex align-items-center gap-2"
                  style={{ transition: 'all 0.2s ease', cursor: 'pointer' }}
                  onMouseEnter={(e) => {
                    const button = e.currentTarget.querySelector('button')
                    const text = e.currentTarget.querySelector('span')
                    if (button) {
                      button.style.backgroundColor = '#223843'
                      button.style.borderColor = '#223843'
                      button.style.color = '#ffffff'
                      button.style.transform = 'scale(1.05)'
                    }
                    if (text) {
                      text.style.transform = 'scale(1.05)'
                    }
                    e.currentTarget.style.transform = 'scale(1.02)'
                  }}
                  onMouseLeave={(e) => {
                    const button = e.currentTarget.querySelector('button')
                    const text = e.currentTarget.querySelector('span')
                    if (button) {
                      button.style.backgroundColor = '#ffffff'
                      button.style.borderColor = '#D1D3D4'
                      button.style.color = '#111827'
                      button.style.transform = 'scale(1)'
                    }
                    if (text) {
                      text.style.transform = 'scale(1)'
                    }
                    e.currentTarget.style.transform = 'scale(1)'
                  }}
                >
                  <button
                    onClick={() =>
                      handleBack(
                        selectedStudent?.id || selectedStudentIdParams?.id,
                      )
                    }
                    style={{
                      width: '48px',
                      height: '48px',
                      borderRadius: '50%',
                      border: '1px solid #D1D3D4',
                      backgroundColor: '#ffffff',
                      color: '#111827',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      cursor: 'pointer',
                      transition: 'all 0.2s ease',
                      flexShrink: 0,
                    }}
                    title={`Go to ${selectedStudent?.name || selectedStudentIdParams?.name} profile`}
                  >
                    <FaArrowLeft size={20} />
                  </button>
                  {!isMobile && (
                    <span style={{ 
                      fontSize: '14px', 
                      color: '#111827', 
                      fontFamily: 'Inter, system-ui, sans-serif', 
                      fontWeight: '500',
                      transition: 'transform 0.2s ease',
                      display: 'inline-block',
                    }}>
                      Go to{' '}
                      <span className="fw-bold">
                        {selectedStudent?.name || selectedStudentIdParams?.name}
                      </span>{' '}
                      profile
                    </span>
                  )}
                </div>
              </div>
            )}
            <div className="order-3 order-md-2 ms-md-auto d-flex gap-2 flex-wrap align-items-center">
              <div
                className="d-flex align-items-center gap-2"
                style={{ transition: 'all 0.2s ease', cursor: 'pointer' }}
                onMouseEnter={(e) => {
                  const button = e.currentTarget.querySelector('button')
                  const text = e.currentTarget.querySelector('span')
                  if (button && !button.disabled) {
                    button.style.backgroundColor = '#059669'
                    button.style.borderColor = '#059669'
                    button.style.transform = 'scale(1.05)'
                  }
                  if (text) {
                    text.style.transform = 'scale(1.05)'
                  }
                  e.currentTarget.style.transform = 'scale(1.02)'
                }}
                onMouseLeave={(e) => {
                  const button = e.currentTarget.querySelector('button')
                  const text = e.currentTarget.querySelector('span')
                  if (button) {
                    button.style.backgroundColor = '#10B981'
                    button.style.borderColor = '#10B981'
                    button.style.transform = 'scale(1)'
                  }
                  if (text) {
                    text.style.transform = 'scale(1)'
                  }
                  e.currentTarget.style.transform = 'scale(1)'
                }}
              >
                <button
                  onClick={() => handleTakeFeesButton()}
                  style={{
                    width: '48px',
                    height: '48px',
                    borderRadius: '50%',
                    border: '1px solid #10B981',
                    backgroundColor: '#10B981',
                    color: '#ffffff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    flexShrink: 0,
                  }}
                  title="Take Fees"
                >
                  <BsCurrencyRupee size={20} />
                </button>
                {!isMobile && (
                  <span style={{ 
                    fontSize: '14px', 
                    color: '#111827', 
                    fontFamily: 'Inter, system-ui, sans-serif', 
                    fontWeight: '500',
                    transition: 'transform 0.2s ease',
                    display: 'inline-block',
                  }}>
                    Take Fees
                  </span>
                )}
              </div>
              <div
                className="d-flex align-items-center gap-2"
                style={{ transition: 'all 0.2s ease', cursor: selectedFees.length === 0 ? 'not-allowed' : 'pointer' }}
                onMouseEnter={(e) => {
                  const button = e.currentTarget.querySelector('button')
                  const text = e.currentTarget.querySelector('span')
                  if (button && !button.disabled && selectedFees.length > 0) {
                    button.style.backgroundColor = '#223843'
                    button.style.borderColor = '#223843'
                    button.style.transform = 'scale(1.05)'
                  }
                  if (text && selectedFees.length > 0) {
                    text.style.transform = 'scale(1.05)'
                  }
                  if (selectedFees.length > 0) {
                    e.currentTarget.style.transform = 'scale(1.02)'
                  }
                }}
                onMouseLeave={(e) => {
                  const button = e.currentTarget.querySelector('button')
                  const text = e.currentTarget.querySelector('span')
                  if (button) {
                    button.style.backgroundColor = selectedFees.length === 0 ? '#9ca3af' : '#223843'
                    button.style.borderColor = selectedFees.length === 0 ? '#D1D3D4' : '#223843'
                    button.style.transform = 'scale(1)'
                  }
                  if (text) {
                    text.style.transform = 'scale(1)'
                  }
                  e.currentTarget.style.transform = 'scale(1)'
                }}
              >
                <button
                  onClick={() => handlePrint()}
                  disabled={selectedFees.length === 0}
                  style={{
                    width: '48px',
                    height: '48px',
                    borderRadius: '50%',
                    border: selectedFees.length === 0 ? '1px solid #D1D3D4' : '1px solid #223843',
                    backgroundColor: selectedFees.length === 0 ? '#9ca3af' : '#223843',
                    color: '#ffffff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: selectedFees.length === 0 ? 'not-allowed' : 'pointer',
                    transition: 'all 0.2s ease',
                    flexShrink: 0,
                    opacity: selectedFees.length === 0 ? 0.6 : 1,
                  }}
                  title={selectedFees.length === 0 ? 'Please select fees to print' : 'Print Receipt'}
                >
                  <BsPrinterFill size={20} />
                </button>
                {!isMobile && (
                  <span style={{ 
                    fontSize: '14px', 
                    color: '#111827', 
                    fontFamily: 'Inter, system-ui, sans-serif', 
                    fontWeight: '500',
                    transition: 'transform 0.2s ease',
                    display: 'inline-block',
                    opacity: selectedFees.length === 0 ? 0.6 : 1,
                  }}>
                    Print Receipt
                  </span>
                )}
              </div>
            </div>
          </div>
        )}

        {/* Table */}
        {openTable && (
          <Card style={{ border: '1px solid #D1D3D4', borderRadius: '12px', overflow: 'hidden', backgroundColor: '#ffffff' }}>
            <div style={{ overflowX: 'auto', overflowY: 'visible', position: 'relative', borderRadius: '12px', maxWidth: '100%' }}>
            <Table className="table mb-0" style={{ borderRadius: '12px', overflow: 'visible', minWidth: 'max-content' }}>
              <Thead>
                <Tr style={{ backgroundColor: '#F3F4F6' }}>
                  <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'center', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Select</Th>
                  <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Fees Name</Th>
                  <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Course</Th>
                  <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Amount</Th>
                  <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Start Date</Th>
                  <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>End Date</Th>
                  <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Transaction ID</Th>
                  <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Transaction Amount</Th>
                  <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Discount</Th>
                  <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Payment Method</Th>
                  <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Online</Th>
                  <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Cash</Th>
                  <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Transaction Date</Th>
                  <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Taken By</Th>
                  <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Status</Th>
                  <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'center', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Action</Th>
                </Tr>
              </Thead>
              <Tbody>
                {/* Check if a student is selected */}
                {(!selectedStudentId && !selectedStudentIdParams?.id) ||
                !selectedCourseId ? (
                  <Tr>
                    <Td colSpan="16" className="text-center" style={{ padding: '40px', fontSize: '14px', color: '#6b7280', fontFamily: 'Inter, system-ui, sans-serif' }}>
                      Please select a student and course
                    </Td>
                  </Tr>
                ) : selectedData.length === 0 ? (
                  <Tr>
                    <Td colSpan="16" className="text-center" style={{ padding: '40px', fontSize: '14px', color: '#6b7280', fontFamily: 'Inter, system-ui, sans-serif' }}>
                      No data found
                    </Td>
                  </Tr>
                ) : (
                  selectedData
                    .filter(
                      (fee) =>
                        fee.fees_status === 'pending' ||
                        fee.fees_status === 'complete',
                    )
                    .map((fee, index) => {
                      return (
                        <Tr 
                          key={fee.id}
                          style={{ 
                            backgroundColor: index % 2 === 0 ? '#ffffff' : 'rgba(243, 244, 246, 0.4)',
                            transition: 'background-color 0.2s ease',
                            borderBottom: '1px solid #E5E7EB',
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = 'rgba(37, 99, 235, 0.06)'
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#ffffff' : 'rgba(243, 244, 246, 0.4)'
                          }}
                        >
                          <Td className="text-center" style={{ fontSize: '14px', padding: '16px', border: 'none', fontFamily: 'Inter, system-ui, sans-serif' }}>
                            {fee.fees_status === 'complete' && (
                              <input
                                style={{
                                  cursor: 'pointer',
                                  width: '20px',
                                  height: '20px',
                                }}
                                type="checkbox"
                                onChange={() => handleSelectFee(fee.id)}
                                checked={selectedFees.includes(fee.id)}
                              />
                            )}
                          </Td>

                          <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>
                            {fee.fees_name?.charAt(0).toUpperCase() +
                              fee.fees_name?.slice(1)}
                          </Td>
                          <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>{fee.course_name}</Td>

                          <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>₹ {fee.amount}</Td>
                          <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>{formatFeeDate(fee.start_date)}</Td>
                          <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>{formatFeeDate(fee.end_date)}</Td>
                          <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>{fee.transaction_id || '-'}</Td>
                          <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>
                            {fee.transaction_amount
                              ? `₹${fee.transaction_amount}`
                              : '-'}
                          </Td>
                          <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}> {fee.discount ? `₹${fee.discount}` : '-'} </Td>
                          <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>
                            {fee.payment_method
                              ? fee.payment_method.charAt(0).toUpperCase() +
                                fee.payment_method.slice(1)
                              : 'N/A'}
                          </Td>
                          <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>
                            {formatINR(getOnlineAmount(fee))}
                          </Td>
                          <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>
                            {formatINR(getCashAmount(fee))}
                          </Td>

                          <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>
                            {fee.transaction_date
                              ? new Date(
                                  fee.transaction_date,
                                ).toLocaleDateString('en-GB', {
                                  day: '2-digit',
                                  month: 'long',
                                  year: 'numeric',
                                })
                              : '-'}
                          </Td>
                          <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>{fee.taken_by_name || "-"}</Td>
                          <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>
                            <span
                              className="fw-bold"
                              style={{
                                backgroundColor:
                                  fee.fees_status === 'complete'
                                    ? '#d1fae5'
                                    : '#fef3c7',
                                color:
                                  fee.fees_status === 'complete'
                                    ? '#065f46'
                                    : '#92400e',
                                padding: '4px 10px',
                                borderRadius: '20px',
                                fontSize: '0.875rem',
                                fontWeight: 600,
                                textTransform: 'capitalize',
                              }}
                            >
                              {fee.fees_status}
                            </span>
                          </Td>
                          <Td className="text-center" style={{ fontSize: '14px', padding: '16px', border: 'none', fontFamily: 'Inter, system-ui, sans-serif', position: 'relative', overflow: 'visible' }}>
                            <Dropdown align="end">
                              <Dropdown.Toggle
                                variant="light"
                                id={`fee-action-${fee.id}`}
                                className="dropdown-toggle-no-caret"
                                style={{
                                  width: '36px',
                                  height: '36px',
                                  borderRadius: '50%',
                                  backgroundColor: 'transparent',
                                  border: '1px solid #D1D3D4',
                                  padding: '0',
                                  display: 'inline-flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  transition: 'all 0.2s ease',
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor = '#223843'
                                  e.currentTarget.style.borderColor = '#223843'
                                  e.currentTarget.style.color = '#ffffff'
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor = 'transparent'
                                  e.currentTarget.style.borderColor = '#D1D3D4'
                                  e.currentTarget.style.color = '#111827'
                                }}
                              >
                                <BsThreeDotsVertical style={{ color: 'inherit' }} />
                              </Dropdown.Toggle>
                              <Dropdown.Menu
                                renderOnMount
                                popperConfig={{
                                  strategy: 'fixed',
                                  modifiers: [
                                    {
                                      name: 'offset',
                                      options: { offset: [0, 8] },
                                    },
                                    {
                                      name: 'flip',
                                      options: {
                                        fallbackPlacements: ['top-end', 'bottom-end', 'left-start'],
                                      },
                                    },
                                    {
                                      name: 'preventOverflow',
                                      options: {
                                        boundary: 'viewport',
                                        padding: 8,
                                      },
                                    },
                                  ],
                                }}
                                style={{
                                  borderRadius: '8px',
                                  border: '1px solid #D1D3D4',
                                  padding: '8px',
                                  minWidth: '160px',
                                }}
                              >
                                <Dropdown.Item
                                  onClick={() => {
                                    setSelectedTransactionId(fee.id)
                                    setShowEditModal(true)
                                  }}
                                  style={{
                                    fontSize: '13px',
                                    padding: '10px 12px',
                                    color: '#111827',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                    borderRadius: '6px',
                                    fontFamily: 'Inter, system-ui, sans-serif',
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor = '#F59E0B'
                                    e.currentTarget.style.color = '#ffffff'
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor = 'transparent'
                                    e.currentTarget.style.color = '#111827'
                                  }}
                                >
                                  <BsPencilFill size={16} /> Edit Fee
                                </Dropdown.Item>
                                <Dropdown.Item
                                  onClick={() => {
                                    navigate(`/FeeChangeLogs/${fee.id}`, {
                                      state: {
                                        studentName:
                                          selectedStudent?.name ||
                                          selectedStudentIdParams?.name ||
                                          '',
                                        admissionNumber:
                                          selectedStudent?.admission_number ||
                                          selectedStudentIdParams?.admission_number ||
                                          '',
                                        feeName: fee.fees_name || '',
                                        feeAmount: fee.amount || '',
                                        feeStatus: fee.fees_status || '',
                                      },
                                    })
                                  }}
                                  style={{
                                    fontSize: '13px',
                                    padding: '10px 12px',
                                    color: '#111827',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                    borderRadius: '6px',
                                    fontFamily: 'Inter, system-ui, sans-serif',
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor = '#223843'
                                    e.currentTarget.style.color = '#ffffff'
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor = 'transparent'
                                    e.currentTarget.style.color = '#111827'
                                  }}
                                >
                                  <BsClockHistory size={16} /> View Changes
                                </Dropdown.Item>
                                <Dropdown.Item
                                  disabled={fee.fees_status !== 'pending'}
                                  onClick={() => {
                                    if (fee.fees_status !== 'pending') return
                                    setFeeToCancel(fee)
                                    setShowCancelModal(true)
                                  }}
                                  style={{
                                    fontSize: '13px',
                                    padding: '10px 12px',
                                    color: fee.fees_status !== 'pending' ? '#9ca3af' : '#111827',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                    borderRadius: '6px',
                                    fontFamily: 'Inter, system-ui, sans-serif',
                                    cursor: fee.fees_status !== 'pending' ? 'not-allowed' : 'pointer',
                                  }}
                                  onMouseEnter={(e) => {
                                    if (fee.fees_status !== 'pending') return
                                    e.currentTarget.style.backgroundColor = '#EF4444'
                                    e.currentTarget.style.color = '#ffffff'
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor = 'transparent'
                                    e.currentTarget.style.color =
                                      fee.fees_status !== 'pending' ? '#9ca3af' : '#111827'
                                  }}
                                >
                                  <BsTrashFill size={16} /> Delete Fee
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </Td>
                        </Tr>
                      )
                    })
                )}
              </Tbody>
            </Table>
            </div>
          </Card>
        )}

        {showCancelModal && feeToCancel && (
          <Modal
            size="lg"
            show={showCancelModal}
            onHide={() => {
              if (!isCancelling) {
                setShowCancelModal(false)
                setFeeToCancel(null)
              }
            }}
            centered
          >
            <Modal.Header closeButton closeVariant="white" className="bg-danger text-white">
              <Modal.Title className="text-white fw-bold" style={{ letterSpacing: '1px' }}>
                Confirm Cancellation
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p className="mb-2 fw-semibold" style={{ letterSpacing: '1px' }}>
                Are you sure you want to cancel this fee?
              </p>
              <div>
                <strong>Student:</strong>{' '}
                <span className="fw-semibold">
                  {selectedStudent?.name?.toUpperCase() ||
                    selectedStudentIdParams?.name?.toUpperCase() ||
                    '-'}
                </span>
                <br />
                <strong>Fee Name:</strong>{' '}
                <span className="fw-semibold">
                  {feeToCancel?.fees_name?.toUpperCase() || '-'}
                </span>
                <br />
                <strong>Amount:</strong>{' '}
                <span className="text-danger fw-bold">₹ {feeToCancel?.amount || 'N/A'}</span>
              </div>
              <hr />
              <p className="text-muted mb-0">
                Once cancelled, this fee record will no longer be visible or available for further actions.
              </p>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => {
                  setShowCancelModal(false)
                  setFeeToCancel(null)
                }}
                disabled={isCancelling}
              >
                Close
              </Button>
              <Button variant="danger" disabled={isCancelling} onClick={handleConfirmCancel}>
                {isCancelling ? 'Cancelling...' : 'Confirm Cancel'}
              </Button>
            </Modal.Footer>
          </Modal>
        )}

        <EditTransactionModal
          show={showEditModal}
          data={selectedData}
          selectedId={selectedTransactionId}
          onHide={() => {
            setShowEditModal(false)
            setSelectedTransactionId(null)
          }}
          onUpdate={refreshFeesList}
        />
        </div>
      </div>
    </>
  )
}
